module.exports = __webpack_public_path__ + "img/graden5.0ae2f8c1.png";